import React from 'react';
import ContentLoader from 'react-content-loader';

const CommandLoader = () => (
  <div>
    <ContentLoader
      height={360}
      width={208}
      speed={2}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="6" y="9" rx="0" ry="0" width="150" height="10" />
      <rect x="7" y="34" rx="0" ry="0" width="90" height="10" />
      <rect x="108" y="34" rx="0" ry="0" width="90" height="10" />

      <rect x="7" y="55" rx="0" ry="0" width="190" height="10" />

      <rect x="7" y="74" rx="0" ry="0" width="56" height="8" />
      <rect x="108" y="74" rx="0" ry="0" width="56" height="8" />

      <rect x="7" y="95" rx="0" ry="0" width="87" height="10" />
      <rect x="108" y="95" rx="0" ry="0" width="87" height="10" />

      <rect x="7" y="118" rx="0" ry="0" width="87" height="10" />
      <rect x="108" y="118" rx="0" ry="0" width="87" height="10" />

      <rect x="7" y="138" rx="0" ry="0" width="87" height="10" />
      <rect x="108" y="138" rx="0" ry="0" width="87" height="10" />

      <rect x="7" y="160" rx="0" ry="0" width="87" height="10" />
      <rect x="108" y="160" rx="0" ry="0" width="87" height="10" />
    </ContentLoader>
  </div>
);

export default CommandLoader;
